import React from 'react';
import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';

export const ACCESS_DENIED_MESSAGE = 'Access denied. Please contact your admin for access.';

/**
 * Standard access-denied screen shown whenever a learner tries to reach a
 * course (or content) they are not enrolled in. Never render a blank page or
 * raw error - always this clear state.
 */
export default function AccessDenied({ message = ACCESS_DENIED_MESSAGE, showDashboardLink = true }) {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4" data-testid="access-denied-screen">
      <div className="max-w-md w-full text-center bg-navigate-dark border border-zinc-800 rounded-2xl p-10">
        <div className="mx-auto mb-6 h-16 w-16 rounded-full bg-amber-500/10 border border-amber-500/30 flex items-center justify-center">
          <Lock className="h-8 w-8 text-amber-400" />
        </div>
        <h1 className="text-xl font-semibold text-white mb-2">Access denied</h1>
        <p className="text-zinc-400 mb-8">{message}</p>
        {showDashboardLink && (
          <Link
            to="/dashboard"
            className="btn-gold inline-flex items-center justify-center px-6 py-2.5"
            data-testid="access-denied-dashboard-btn"
          >
            Back to Dashboard
          </Link>
        )}
      </div>
    </div>
  );
}
